// 测试加载
export function testLoaded(): void {
  console.log("loaded successfully!");
}

// 常量集合
export * from "./constants/index.js";

// 字符串
export * from "./string/index.js";
// 数字
export * from "./number/index.js";
// 数组
export * from "./array/index.js";
// 对象
export * from "./object/index.js";
// 函数
export * from "./function/index.js";
// 日期
export * from "./date/index.js";
// 数学
export * from "./math/index.js";
// 正则
export * from "./regexp/index.js";
// 随机数
export * from "./random/index.js";

// 文件
export * from "./file/index.js";
// 颜色
export * from "./color/index.js";
// 校验
export * from "./validate/index.js";
// 键盘
export * from "./keycode/index.js";

// 生成id
export * from "./id/index.ts";

// 加解密算法
export * from "./crypto/index.js";
// 脱敏
export * from "./desensitized/index.js";
// 身份证号码
export * from "./ID-card/index.js";
// 分页
export * from "./pagination/index.js";

// 浏览器 Url
export * from "./url/index.js";
// 浏览器 Cookie
export * from "./cookie/index.js";
// 浏览器 Storage
export * from "./storage/index.js";
// 浏览器 Dom
export * from "./dom/index.js";
// 浏览器 Device
export * from "./device/index.js";
// 浏览器 Clipboard
export * from "./clipboard/index.js";

// 微信小程序工具
export * from "./weapp/index.js";
